var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17561 5.0352C0.953006 5.03583 0.735127 5.09946 0.54718 5.21875C0.359233 5.33803 0.208899 5.50809 0.113571 5.70926C0.0182426 5.91042 -0.0181844 6.13446 0.00850431 6.35545C0.035193 6.57645 0.123907 6.78538 0.264382 6.95807L3.25898 10.6264C3.36575 10.759 3.50262 10.8642 3.65821 10.9333C3.8138 11.0023 3.98362 11.0333 4.15357 11.0235C4.51705 11.004 4.8452 10.8096 5.05443 10.4899L11.275 0.471694C11.276 0.470033 11.2771 0.468371 11.2781 0.466734C11.3365 0.377116 11.3176 0.199519 11.1971 0.08795C11.164 0.0573118 11.125 0.0337732 11.0825 0.0187837C11.0399 0.00379426 10.9948 -0.00232873 10.9498 0.000792008C10.9048 0.00391274 10.8609 0.0162111 10.8209 0.0369296C10.7808 0.0576481 10.7454 0.0863481 10.7169 0.121262C10.7146 0.124007 10.7123 0.126711 10.71 0.129373L4.43646 7.21749C4.41259 7.24447 4.38359 7.26643 4.35116 7.2821C4.31873 7.29777 4.28351 7.30685 4.24754 7.30879C4.21158 7.31074 4.17558 7.30552 4.14165 7.29343C4.10772 7.28135 4.07653 7.26264 4.04988 7.2384L1.96783 5.34372C1.75159 5.14549 1.46896 5.03543 1.17561 5.0352Z",
    fill: "#3DCBB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick02);
export default __webpack_public_path__ + "static/media/green-tick-02.b6cb049881481df1bde5d02f34feb125.svg";
export { ForwardRef as ReactComponent };